import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';
import { Phone, Clock, ArrowRight, X } from 'lucide-react';

const SESSION_KEY = 'raiseroot_consult_dismissed';

export default function ConsultingPopup() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const dismissed = sessionStorage.getItem(SESSION_KEY);
    if (!dismissed) {
      const timer = setTimeout(() => setOpen(true), 2500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(SESSION_KEY, '1');
    setOpen(false);
  };

  const handleBook = () => {
    sessionStorage.setItem(SESSION_KEY, '1');
    setOpen(false);
    navigate('/consulting');
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleDismiss(); }}>
      <DialogContent className="max-w-md bg-white" data-testid="consulting-popup">
        <DialogHeader>
          <div className="w-12 h-12 bg-gradient-to-br from-primary to-emerald-600 rounded-xl flex items-center justify-center mb-3">
            <Phone className="w-6 h-6 text-white" />
          </div>
          <DialogTitle className="font-heading text-xl">Need Expert Fundraising Guidance?</DialogTitle>
          <DialogDescription className="text-stone-500">
            Book a strategy session with our team. Get structured, focused guidance on grants, proposals, pipeline, and more — no long-term commitment.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2 my-2">
          <div className="flex items-center justify-between p-3 bg-stone-50 rounded-lg">
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-stone-800">30-Minute Strategy Session</span>
            </div>
            <span className="font-bold text-primary">$55</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-stone-50 rounded-lg">
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-stone-800">60-Minute Strategy Session</span>
            </div>
            <span className="font-bold text-primary">$100</span>
          </div>
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="ghost" onClick={handleDismiss} className="text-stone-500" data-testid="consulting-popup-dismiss">
            Maybe Later
          </Button>
          <Button onClick={handleBook} className="bg-primary hover:bg-primary-800 text-white" data-testid="consulting-popup-book">
            <ArrowRight className="w-4 h-4 mr-1" />
            Book a Session
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
